"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../../global-files/variables");

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  max-width: 700px;\n  min-width: 350px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 0px;\n  background: white;\n  padding: 0px;\n  overflow: hidden;\n  border-radius: inherit;\n  //border: 1px solid red;\n\n  .container-chatEmpty {\n    width: 100%;\n    flex-grow: 2;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 18px;\n    background-color: transparent;\n\n    .icon-chat {\n      color: #808080;\n    }\n\n    label {\n      font-family: ", ", sans-serif;\n      font-size: 17px;\n      text-align: center;\n      color: #808080;\n    }\n  }\n  @media (max-width: 600px) {\n    min-width: 300px;\n  }\n"])), _variables.FontFamily.RobotoRegular);

exports.Container = Container;